'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 54
// module chunks = 3 4 6 7 10 12 15 18 19 20 21 22